import script from "./pdfTemplateManager.vue?vue&type=script&lang=js"
export * from "./pdfTemplateManager.vue?vue&type=script&lang=js"

import "./pdfTemplateManager.vue?vue&type=style&index=0&id=625f1072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625f1072"]])

export default __exports__